import * as React from 'react';
import { Apply as SubmitIcon } from '../../../icons';
import { Text } from '../../texts';

const Component = (props) => {
  const { children, isActive } = props;
  return (
    <>
      <Text color={isActive ? 'mainFont' : 'gray'} withEllipsis={true}>
        {children}
      </Text>
      {isActive && <SubmitIcon />}
    </>
  );
};

export const TextItem = React.memo(Component);